module.exports = __webpack_public_path__ + "static/img/ac-aim.7d4d504c.svg";